import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "seperate-account-settle"
};
import { ref } from 'vue';
import SettleList from './settle-list.vue';
import ResultList from './result-list.vue';
export default {
  name: 'index',

  setup(__props) {
    const tab = ref('1');
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tab.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "分账记录",
          name: "1"
        }), _createVNode(_component_el_tab_pane, {
          label: "结算记录",
          name: "2"
        })]),
        _: 1
      }, 8, ["modelValue"]), tab.value === '1' ? (_openBlock(), _createBlock(SettleList, {
        key: 0
      })) : (_openBlock(), _createBlock(ResultList, {
        key: 1
      }))]);
    };
  }

};